import React, {useState} from 'react'
import '../../../../../../../styles/kp-11Generic-catalog-card.css'
import {useDispatch} from 'react-redux'
import {removeItem} from '../../../../../../../app-store/kp11CartSlice'
import useDebouncedCallback from '../../../../../../../utils/useDebouncedCallback'
import {useUserFeatures} from '../../../../../../../context/user-features-context'

const Kp11KeapMaxCard = ({
  name,
  price,
  handleCardAction,
  placeholder,
  isDisabled = false,
  groupKey,
  itemCode,
  entitlements,
  onGroupCustomFieldsUpdate,
  groupCustomFields = {},
}) => {
  const dispatch = useDispatch()
  const userFeatures = useUserFeatures()
  const [keapTrailId, setKeapTrailId] = useState(
    groupCustomFields.keapTrailId || '',
  )
  console.log('setKeapTrailId', setKeapTrailId)
  const [keapDomain, setKeapDomain] = useState(
    groupCustomFields.keapDomain || '',
  )
  const [isKeapTrialClientConversion, setIsKeapTrialClientConversion] =
    useState(groupCustomFields.isKeapTrialClientConversion ?? false)

  const domainPattern =
    /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+\/?$/
  const isValidDomain = keapDomain === '' || domainPattern.test(keapDomain)
  const isDomainInvalid = !isValidDomain

  const getDomainValidationMessage = () => {
    if (!isValidDomain) return 'Enter a valid domain URL'
    return null
  }

  // Handler for free trial conversion selection
  const handleFreeTrialSelection = isTrialSelected => {
    const updatedGroupCustomFields = {
      isKeapTrialClientConversion: isTrialSelected,
      keapTrailId: '',
    }

    setIsKeapTrialClientConversion(isTrialSelected)
    dispatch(removeItem({groupKey, itemCode}))

    onGroupCustomFieldsUpdate(updatedGroupCustomFields)
  }
  console.log('handleFreeTrialSelection : ', handleFreeTrialSelection)

  // Debounced callback for keapDomain
  useDebouncedCallback(
    () => {
      onGroupCustomFieldsUpdate({
        keapDomain,
      })
    },
    [keapDomain],
    500,
  )

  const isSaveButtonDisabled =
    isKeapTrialClientConversion === null ||
    isKeapTrialClientConversion === undefined
      ? true
      : isKeapTrialClientConversion
      ? !keapTrailId
      : false
  const isAddToCartDisabled = isSaveButtonDisabled || isDisabled

  const saveButtonHandler = e => {
    e.stopPropagation()

    if (isSaveButtonDisabled) {
      return
    }

    if (isKeapTrialClientConversion) {
      onGroupCustomFieldsUpdate({
        keapTrailId,
      })
    }

    handleCardAction()
  }

  return (
    <div
      className={`card-plan-item d-flex  ${isDisabled ? 'disabled' : ''}`}
      style={{
        border: 'none',
        boxShadow: 'none',
        paddingInline: '0px',
        paddingTop: '0px',
      }}
    >
      <div className="d-flex justify-content-between w-100">
        <div className="item-content-wrap" style={{flex: 1}}>
          {/* <div className="plan-item-radio-label">{name || 'Keap Max'}</div>
          <div className="plan-item-price">${price || '0'}</div>
          <div className="plan-item-subtext">Billed Monthly</div> */}
          <section className="plan-item-select-wrap">
            <div
              className="checkbox-group"
              style={{display: 'flex', flexDirection: 'column'}}
            >
              {(entitlements || [])
                .filter(
                  entitlement =>
                    !(
                      entitlement.requiresFlags?.length > 0 &&
                      !entitlement.requiresFlags.some(
                        flag => userFeatures[flag],
                      )
                    ),
                )
                .map(entitlement => (
                  <label key={entitlement.id}>
                    <input
                      type="checkbox"
                      checked={Boolean(entitlement.isRequired)}
                      disabled={Boolean(entitlement.isRequired)}
                    />{' '}
                    {entitlement.name} ({entitlement?.quantity})
                  </label>
                ))}
            </div>

            <div className="email-input-wrap">
              <p>Enter Domain Based Email address (Optional)</p>
              {/* keapDomain value */}
              <input
                type="text"
                placeholder={placeholder || 'Enter domain URL'}
                className={`email-input ${
                  isDomainInvalid && keapDomain !== '' ? 'error' : ''
                }`}
                name="keapDomain"
                value={keapDomain}
                onChange={e => setKeapDomain(e.target.value)}
              />
              {isDomainInvalid && keapDomain !== '' && (
                <span className="custom-field-error">
                  {getDomainValidationMessage()}
                </span>
              )}
            </div>

            {/* <div className="radio-text-input-wrap">
              <p>
                Is this a Keap Free Trial Client conversion?{' '}
                <span style={{color: 'red'}}>*</span>
              </p>
              <div className="radio-group">
                <label>
                  <input
                    type="radio"
                    name="yesNo"
                    value="yes"
                    onChange={() => handleFreeTrialSelection(true)}
                    checked={isKeapTrialClientConversion === true}
                  />{' '}
                  Yes
                </label>
                <label style={{marginLeft: '0.5rem'}}>
                  <input
                    type="radio"
                    name="yesNo"
                    value="no"
                    onChange={() => handleFreeTrialSelection(false)}
                    checked={isKeapTrialClientConversion === false}
                  />{' '}
                  No
                </label>
              </div>
              <div
                className="w-full"
                style={{display: 'flex', flexDirection: 'column'}}
              >
                <div className="text-input-wrap">
                  <label htmlFor="keapTrailId">
                    Keap Free Trial App ID{' '}
                    {isKeapTrialClientConversion && (
                      <span style={{color: 'red'}}>*</span>
                    )}
                  </label>
                  <input
                    type="text"
                    placeholder="Keap Free Trial App ID"
                    className="text-input"
                    name="keapTrailId"
                    value={keapTrailId}
                    onChange={e => {
                      setKeapTrailId(e.target.value)
                    }}
                  />
                </div>
              </div>
            </div> */}

            <button
              type="button"
              style={{
                marginTop: '1rem',
                marginLeft: 'auto',
                display: 'block',
                backgroundColor: isAddToCartDisabled ? '#ccc' : '#FF6100',
                border: 'none',
                color: isAddToCartDisabled ? '#888' : 'white',
                padding: '0.2rem 0.5rem',
                borderRadius: '0.5px',
                fontWeight: 'bold',
                width: '35%',
                opacity: isAddToCartDisabled ? 0.7 : 1,
                transition: 'background-color 0.2s',
              }}
              onClick={e => saveButtonHandler(e)}
              disabled={isAddToCartDisabled}
            >
              Add to Cart
            </button>
          </section>
        </div>
      </div>
    </div>
  )
}
export default Kp11KeapMaxCard
